export const defaultSelectedPlaneacionAuditoria = () => {
  return {
    id_empresa: '',
    id_planeacion: '',
    id_lista_chequeo: '',
    id_tipo_seguimiento: [],
    evidencia: '',

  };
};
export const defaultSelectedPlaneacion = () => {
  return {
    id_empresa: '',
    id_tipo_lista_chequeo: '',
    objetivo: '',
    alcance: '',
    ambito_aplicacion: '',
    documentos_referencia: '',
    nombre_empleado: '',
    cargo_empleado: '',
    ubicaciones: '',
    planeacion_auditoria: []
  };
};

export const defaultSelectedRegistro = () => {
  return {
    id_empresa: "",
    id_planeacion: "",
    id_item: "",
    registro: "",
  };
};

export const filtro = () => {
  return {
    id_empresa: null,
    paginado: true,
    page: 1,
    perPage: 10,
    sortBy: 'id',
    sort: 'DESC'
  };
};
export default {
  selectedPlaneacion: defaultSelectedPlaneacion(),
  selectedPlaneacionAuditoria: defaultSelectedPlaneacionAuditoria(),
  selectedRegistro: defaultSelectedRegistro(),
  planeacionesAuditorias: [],
  planeacionesAuditoriasHallazgos: [],
  tipoListaChequeo: [],
  tipoSeguimiento: [],
  listaTipoSeguimientos: [],
  empresas: [],
  empresas_filtro: [],
  listaRegistros: [],
  hallazgoArr: [],
  accion: 'Crear',
  id_lista_chequeo: '',
  cargando_datos_select: false,
  filtro: filtro(),
  filtroRegistro: {
    id_empresa: '',
    id_planeacion: '',
    id_item: '',
    page: 1,
    perPage: 10,
    sortBy: 'id',
    sort: 'DESC',
  },
  modal: {
    ver: false
  }
};
